// extracted by mini-css-extract-plugin
export default {"link":"tooltip_link__YDFJf","tooltipContainer":"tooltip_tooltipContainer__f4c5J"};